import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Spin, message } from "antd";
import axios from "axios";
import styled from "styled-components";
import { AuthConstant } from "../../constants/AuthConstant";
import LoginBackGroundImage from "../../assets/voyager/LoginBackGroundImage.png";
import { BASEURL } from "../../BaseUrl";
import { currentEnvConfig } from "../../constants/AuthConstant";

const Login = () => {
  const navigate = useNavigate();
  const [code, setcode] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "Not able to Authenticate",
    });
  };

  const Container = styled.div`
    background-image: url(${LoginBackGroundImage});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const {
    client_id,
    authorization_endpoint,
    redirect_uri,
    response_type,
    response_mode,
    scope,
    state,
  } = AuthConstant[currentEnvConfig];

  const authenticateUser = async () => {
    try {
      const LOGIN_URI = `${authorization_endpoint}?client_id=${client_id}&state=${state}&response_type=${response_type}&redirect_uri=${redirect_uri}&response_mode=${response_mode}&scope=${scope}`;
      window.location.replace(LOGIN_URI);
      //  navigate("/dep/dashboard", {
      //   state: {
      //     roles: ["admin"],
      //     refreshToken: "",
      //     accessToken:
      //       "eyJ0eXAiOiJKV1QiLCJub25jZSI6IjZXVHVuVHh2Q3owbkFUdjRqd2dmVE9VUy1jSm1jRnVEQjBWei1rVXpmc1UiLCJhbGciOiJSUzI1NiIsIng1dCI6IkpZaEFjVFBNWl9MWDZEQmxPV1E3SG4wTmVYRSIsImtpZCI6IkpZaEFjVFBNWl9MWDZEQmxPV1E3SG4wTmVYRSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xZTQ1ODJlOC0yMjBhLTRmMTctOTBmMC1mZmE5NDY4N2Y3YjQvIiwiaWF0IjoxNzUzMjU1NTM1LCJuYmYiOjE3NTMyNTU1MzUsImV4cCI6MTc1MzI1OTk5MywiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiXSwiYWlvIjoiQVpRQWEvOFpBQUFBbDVreld1cXBIR08vZm1UV2xQRVJVTXFzOFVqZUVrSHBMWlo0NEFGQ0k3bW9HUkVwdWJOUndKMkN2NGlpWllGazE1Z2RiMFJJUFIzWFlmWWc5Q1oyaE9IdjVzcTNkcE9KOGI2Y3ZSSis0MDN4MHlKM2hkeFFiZG1vNnZjdDlPS2lOdllzcDZkTFB0dGppY01WYmpKMmRVUnZXc0x4eCt0NUZOV0k1aWsyMldtY2JUemswUUMwUDJ0QVN4V2g4VXQyIiwiYW1yIjpbInB3ZCIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJWREVQIiwiYXBwaWQiOiIxMjZhYWQxMy1mMWYxLTRlZmUtOTlmNy1lMDdmMzA5OTcyNjQiLCJhcHBpZGFjciI6IjEiLCJmYW1pbHlfbmFtZSI6IlNvbmkiLCJnaXZlbl9uYW1lIjoiTmFuZGluaSIsImlkdHlwIjoidXNlciIsImlwYWRkciI6IjEwMy4xMTYuODUuNzkiLCJuYW1lIjoiTmFuZGluaSBTb25pIiwib2lkIjoiZjM3NmIyMDgtMmEwZC00YzRmLTlkY2MtMGEyNjY4YWYzNTQxIiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTIwNDg0OTA1ODAtMjg0NjA0ODEzNi0zNTk1NTIzMTA3LTQwMzYxIiwicGxhdGYiOiIzIiwicHVpZCI6IjEwMDMyMDAzRTREMjAzN0UiLCJyaCI6IjEuQVc0QTZJSkZIZ29pRjAtUThQLXBSb2YzdEFNQUFBQUFBQUFBd0FBQUFBQUFBQUJ1QU9adUFBLiIsInNjcCI6ImVtYWlsIG9wZW5pZCBwcm9maWxlIiwic2lkIjoiMDA2ZTVhMTktYzc3Mi02MTQ4LTk5NWYtNzNjMzk4OGEzOGJiIiwic3ViIjoiU05HM0R0MU9aWUFxSnB4QWxDdW5aYWx6Z3lYOVdmanVTdzlLWUI0OW5yUSIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJOQSIsInRpZCI6IjFlNDU4MmU4LTIyMGEtNGYxNy05MGYwLWZmYTk0Njg3ZjdiNCIsInVuaXF1ZV9uYW1lIjoibnNvbmlAdnlnci5jb20iLCJ1cG4iOiJuc29uaUB2eWdyLmNvbSIsInV0aSI6ImFpN3N2WEtKVDBLYjI0RWZKdmtYQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfZnRkIjoiNk5lUFFiTkNjc2kzbU9PLW51M0VBZ3pKYUk1blRRTEhRamt6QnpMQVBnVUJkWE51YjNKMGFDMWtjMjF6IiwieG1zX2lkcmVsIjoiMSAxNCIsInhtc19zdCI6eyJzdWIiOiJqZl9HSlJBQ2JHcl9ub0pKM0hkem1hcnNScHM1UDFVdkVYWU9GU2dkTjljIn0sInhtc190Y2R0IjoxMzc2MDc5MTg3fQ.mncH_PUGgTbX0hAbOh9Y13mSE74iybSOWzHrbc9CYI-DPQtXVKiwgNVwzXbiqX77vsZJ6PLVnOOsIKMDzu9pQ5l3IgsNreRkszuZhjOI6zWr2yj71SWCrHno1aUneDErZq8J3hXyEqllYsNEpOiwOWCJG90txguDnzeYiQo7cNgurC895IQ6GHOmLSdDDZm6NKGApkGgONcFUiW2sa9F-rUiKXdozVMud3kp3rWwss_PqmG4vWREnnRFqKqQcnP-mlZY65S8hsYG0sU9c6hp2RdZ-FiVJjDZ8lU5trWZWUXr8TuJwmWTVd2NIaJGEyrva6qk3l4a-Y0j_xU6DhbJUA",
      //     isAuthenticated: true,
      //     isAdmin: true,
      //     userId: "jf_GJRACbGr_noJJ3HdzmarsRps5P1UvEXYOFSgdN9c",
      //     username: "nsoni@vygr.com",
      //     email: "nsoni@vygr.com",
      //   },
      // });
    } catch (error) {
      console.log(error);
      errorMessage();
    }
  };

  const fetchToken = async (code) => {
    try {
      const loginEndpoint = AuthConstant[currentEnvConfig]?.login_endpoint;

      if (!loginEndpoint) {
        throw new Error("Login endpoint not found for the current environment");
      }

      const response = await axios.get(`${BASEURL}/${loginEndpoint}`, {
        params: { code },
      });
      if (response.status === 200) {
        navigate("/dep/dashboard", {
          state: {
            roles: response.data.roles,
            refreshToken: response.data.refreshToken,
            accessToken: response.data.accessToken,
            isAuthenticated: response.data.authenticated,
            isAdmin: response.data.admin,
            userId: response.data.userId,
            username: response.data.email,
          },
        });
      }
    } catch (error) {
      setcode(null);
      window.location.replace(AuthConstant[currentEnvConfig].redirect_uri);
    }
  };

  useEffect(() => {
    console.log("navigate called");

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    console.log("OAuth Code:", code);
    setcode(code);

    if (code) {
      fetchToken(code);
    }
  }, [navigate]);

  return (
    <>
      {code === null && (
        <>
          <Container>
            <Button type="primary" onClick={authenticateUser}>
              LOGIN
            </Button>
          </Container>
        </>
      )}
      {code !== null && (
        <>
          <Spin fullscreen tip="Loading" size="large">
            <div
              style={{
                padding: 50,
                background: "rgba(0, 0, 0, 0.05)",
                borderRadius: 4,
              }}
            />
            ;
          </Spin>
        </>
      )}
    </>
  );
};

export default Login;
